export class RecruiterRequest {
  public company: string = "";
  public searchString: string = "";
  public pageNumber: number = 1;
  public pageSize: number = 5;
}
